<div class="modal-content">
  <div class="modal-header">
    <p class="modal-title"><strong>{{'TASK_RECORD_CUSTOM_STATISTICS_DIAGRAM_ADD' | translate}}</strong></p>
    <button type="button" class="close" (click)="closeDialog(false)" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <form [formGroup]='formGroup' (ngSubmit)="addNewField()" #f="ngForm">
    <div class="modal-body">
      <mat-dialog-content [ngStyle]="{'overflow': 'visible'}">

          <div class="form-group row"
               [ngClass]="{ 'has-danger': hasLocalFieldError('selectedField')}">
            <div class="col-md-4">
              <label class="col-form-label mw-100 form-control-label required-field-label">
                {{'COMMON_FORM_FIELD'|translate}}
              </label>
            </div>
            <div class="col-md-8">
              <angular2-multiselect [data]="fields" [settings]="dropDownSettings"
                                    class="form-control"
                                    [(ngModel)]="_selectedField"
                                    formControlName="selectedField">
              </angular2-multiselect>
              <div class="form-control-feedback"
                   *ngIf="hasLocalFieldError('selectedField')">
                {{'COMMON_VALIDATION_MESSAGE_REQUIRED' | translate}}
              </div>
            </div>
          </div>
      </mat-dialog-content>
    </div>
    <div class="modal-footer justify-content-end">
        <span>
          <button type="button" class="btn btn-outline-primary" (click)="closeDialog(false)">
            {{'COMMON_BUTTON_CANCEL' | translate}}
          </button>
          <button type="submit" class="btn btn-primary ml-1"
                  [ladda]="creationInProgress"
                  [disabled]="creationInProgress">
            {{'COMMON_BUTTON_SAVE' | translate}}
          </button>
        </span>
    </div>
  </form>
</div><!-- /.modal-content -->
